import Biblioteca from '@/components/Repositorio/Biblioteca';

export default {
  eCodigoBalancaInterno(codigo_barras) {
    if (
      (codigo_barras) &&
      (codigo_barras.length == 13) &&
      (codigo_barras.charAt(0) == '2')
    ) {
      return true;
    }

    return false;
  },

  eCodigoBarraProdutoInterno(codigo_barras) {
    let checagem = '' + codigo_barras;

    if ((!checagem) || (checagem == '')) {
      return false;
    }

    if 
      (
        (checagem.length == 13) &&
        (checagem.charAt(1) == '2')
      ) 
    {
      return true;
    }

    if 
      (
        (checagem.length == 13) &&
        (checagem.substring(0, 2) == 'ADM')
      ) 
    {
      return true;
    }

    return false;
  },

  TratarCodigoBarraInterno(
    codigo_barras,
    tratar_codigo_balanca,
    tratar_codigo_gondola,
    tratar_codigo_uma,
    utiliza_balanca
  ) {
    if ((!retorno) || (retorno == '')) {
      return undefined;
    }

    let retorno = codigo_barras;
    
    
    if ((codigo_barras.length == 11) && (codigo_barras[0] == 'U')) {
      return Biblioteca.valor(codigo.substring(codigo_barras, 1, 10));
    }

    /* 
      985 Foi um código definido para identificar que a etiqueta
      oi gerada pelo ADM pegado Codigo do Orcamento mais ITEM_ID
    */
    if (
      (Copy(codigo_barras, 0, 2) == '985') &&
      (this.eCodigoBarraProdutoInterno(codigo_barras))
     ) { 
      return codigo_barras;
    }

    /* 984 Foi um código definido para identificar promoção relâmpago. */
    if (
      (codigo_barras.substring(0, 2) == '984') &&
      (codigo_barras.length == 16)
     ) {
      return codigo_barras.substr(3, 10);
    }

    if (this.eCodigoBarraProdutoInterno(codigo_barras)) {
      return codigo_barras.substring(
        codigo_barras.length - 7,
        codigo_barras.length -1
      );
    }

    if (
      (utiliza_balanca == 'S') &&
      (tratar_codigo_balanca) &&
      (this.eCodigoBalancaInterno(codigo_barras))
    ) {
      return codigo_barras.substring(1, 4);
    }
    
    if (tratar_codigo_gondola && (Length(codigo_barras) == 16)) {
      return codigo_barras.substring(0, 6);
    }

    /* Balança Filizola */
    if (
      (Length(codigo_barras) == 13) && 
      (codigo_barras.charAt(0) == '2') &&
      (tratar_codigo_balanca) &&
      (utiliza_balanca == 'S')
    ) {
      return codigo_barras.substring(1, 7);
    }

    let numeros = Bibliote.valorInt(codigo_barras);
    if (numeros) {
      if (tratar_codigo_uma || (numeros.toString.length <= 7)) {
        return numeros;
      }
    }
    
    return codigo_barras;
  },

  extrairQuantidadeCodigoBalancaInterno(codigo_barras) {
    if (this.eCodigoBalancaInterno(codigo_barras)) {
      return Biblioteca.valor(codigo_barras.substring(9, 13));
    }

    return 0;
  }
}


// WEBPACK FOOTER //
// ./src/components/Repositorio/ValidacaoCodigoBarras.js